'use client';

import { useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { type ISourceOptions } from "@tsparticles/engine";
import { loadSlim } from "@tsparticles/slim"; 

export function ParticleBackground() {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesLoaded = (container?: any): Promise<void> => {
    // console.log("Particles loaded", container);
    return Promise.resolve();
  };

  const options: ISourceOptions = useMemo(
    () => ({
      background: {
        color: {
          value: "transparent", // Fundo transparente
        },
      },
      fpsLimit: 60, // Limita o FPS para economizar recursos
      interactivity: {
        events: {
          onHover: {
            enable: true,
            mode: "repulse", // Partículas se afastam do mouse
          },
        },
        modes: {
          repulse: {
            distance: 80,
            duration: 0.4,
          },
        },
      },
      particles: {
        color: {
          value: "#f97316", // Cor laranja da sua marca!
        },
        links: {
          color: "#f97316",
          distance: 150,
          enable: true,
          opacity: 0.3, // Linhas mais sutis
          width: 1,
        },
        move: {
          direction: "none",
          enable: true,
          outModes: {
            default: "bounce",
          },
          random: false,
          speed: 1.5, // Velocidade bem baixa
          straight: false,
        },
        number: {
          density: {
            enable: true,
            area: 800,
          },
          value: 50, // Menos partículas para um visual mais limpo
        },
        opacity: {
          value: 0.4, // Partículas mais sutis
        },
        shape: {
          type: "circle",
        },
        size: {
          value: { min: 1, max: 3 }, // Tamanho pequeno e variado
        },
      },
      detectRetina: true,
    }),
    [],
  );

  if (init) {
    return (
      <Particles
        id="tsparticles"
        particlesLoaded={particlesLoaded}
        options={options}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 0, // Ficará no fundo
        }}
      />
    );
  }

  return <></>;
}